import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {Configurazione} from "../models/configurazione";

@Injectable({
  providedIn: 'root'
})
export class ConfigurazioneGeneraleService {
  url: string;
  flUpdate = true;
  configurazione!: Configurazione;
  configurazioneSubject = new BehaviorSubject<Configurazione | null>(null);
  configurazione$: Observable<Configurazione | null> = this.configurazioneSubject.asObservable()
  constructor(private httpClient: HttpClient, private route: Router) {
    this.url = 'services/portaleamministrazione/api/impostazione/';
  }

  getAllImpostazioni(): void{
    this.httpClient.get<Configurazione>(this.url + 'get').subscribe({
      next: (res) => {
        this.configurazione = res;
        if(res === null){
          this.flUpdate = false
        }else{
          this.flUpdate = true;
        }
        this.configurazioneSubject.next(this.configurazione)
      },
      error: () => {
        void this.route.navigate(['error']);
      },
      complete: () => {
        document.documentElement.style.setProperty('--primary', this.configurazione.colorePrFrontOffice);
        document.documentElement.style.setProperty('--secondary', this.configurazione.coloreSeFrontOffice);
        document.documentElement.style.setProperty('--tertiary', this.configurazione.coloreTeFrontOffice);
      }
    });
  }
}
